import { Fields } from 'modules/onboarding/legal/components/CompanyStateRegistration/FormContent';

export interface FormContentProps {}

export const FormContent = () => <Fields />;
